module.exports = __webpack_public_path__ + "img/symbol_1.ebe44450.png";